import { Adresse } from './adresse';
export class ContactAdresse {
  public id: number;
  public contactId?: number;
  public description?: string;
  public type?: string;
  public adresse?: Adresse;
}

export class ContactAddressDTOParams {
  //Equivalent to PutContactAdresse
  description?: string;
  type?: string;
  adresse?: {
    structure_LocaliteId?: number;
    structure_RueId?: number;
    structure_RueNumero?: string;
    structure_RueBoite?: string;
    langueId?: number;
    impression_Adresse?: string;
    impression_CodePostal?: string;
    impression_Localite?: string;
    impression_Pays?: string;
    telephone?: string;
    fax?: string;
    gsm?: string;
    site?: string;
    mail?: string;
  };
}
